var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.avatarThumbnail)?_c('b-avatar',{attrs:{"size":_vm.cssSize,"src":_vm.avatarThumbnail}}):(_vm.name)?_c('b-avatar',{staticClass:"bg--primary",attrs:{"size":_vm.cssSize,"text":_vm.getInitialsFromName(_vm.name)}}):_c('b-avatar',{staticClass:"bg--primary",attrs:{"size":_vm.cssSize,"variant":"primary","icon":"people-fill"}})
}
var staticRenderFns = []

export { render, staticRenderFns }